/**
 * Client preference for background Collect&Go product enrichment.
 * Persisted in localStorage; default OFF (opt-in).
 */

const KEY = 'cogo-enrich-enabled'
const CHANGE_EVENT = 'cogo-enrich-enabled-change'

/** Fallback when localStorage is unavailable (tests / SSR). */
let memoryEnabled: boolean | null = null

function readStored(): string | null {
  try {
    return localStorage.getItem(KEY)
  } catch {
    return memoryEnabled == null ? null : memoryEnabled ? '1' : '0'
  }
}

export function isCogoEnrichEnabled(): boolean {
  const v = readStored()
  if (v == null) return false
  return v === '1' || v === 'true'
}

export function setCogoEnrichEnabled(enabled: boolean): void {
  memoryEnabled = enabled
  try {
    localStorage.setItem(KEY, enabled ? '1' : '0')
  } catch {
    /* ignore quota / private mode — memory still updated */
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: enabled }))
  }
}

/** Same-tab + cross-tab updates. */
export function subscribeCogoEnrichEnabled(
  cb: (enabled: boolean) => void
): () => void {
  if (typeof window === 'undefined') return () => {}
  const onStorage = (e: StorageEvent) => {
    if (e.key === KEY || e.key == null) cb(isCogoEnrichEnabled())
  }
  const onCustom = (e: Event) => {
    const detail = (e as CustomEvent).detail
    cb(typeof detail === 'boolean' ? detail : isCogoEnrichEnabled())
  }
  window.addEventListener('storage', onStorage)
  window.addEventListener(CHANGE_EVENT, onCustom)
  return () => {
    window.removeEventListener('storage', onStorage)
    window.removeEventListener(CHANGE_EVENT, onCustom)
  }
}
